<div style="position: relative;">
    <!--<img class="d-none" loading="lazy" src="assets/img/img-pattern.svg" style="position: absolute; top: -25px; left: 100px; z-index: 1;" />-->
    <!--<img class="d-none" loading="lazy" src="assets/img/img-pattern.svg" style="position: absolute; bottom: -25px; right: 100px; z-index: 1;" />-->
    <div class="promotion-single-background d-flex align-items-center position-relative zindex-3"
         [class.rounded]="module?.width == 'CONSTRAINED'">
        <div class="container px-0">
            <div class="row no-gutters d-flex align-items-center justify-content-center px-10">
                <div class="col-12 col-sm-12 col-md-8">
                    <ng-container *ngFor="let item of items">
                        <div class="text-white col-12"
                            [ngClass]="item?.alignment"
                            [style.padding-top.px]="item?.padding"
                            *ngIf="item?.type == 'TEXT'">
                            <h2 class="font-size-35" [innerHTML]="item?.content | safeHtml"></h2>
                        </div>

                        <div class="text-white col-12">
                            <div class="font-size-18"
                                [ngClass]="item?.alignment"
                                [style.padding-top.px]="item?.padding"
                                [style.padding-bottom.px]="item?.padding"
                                *ngIf="item?.type == 'TEXTAREA'">
                                <p>{{ item?.content }}</p>
                            </div>
                        </div>

                        <div class="text-white col-12">
                            <div [ngClass]="item?.alignment"
                                [style.padding-top.px]="item?.padding"
                                [style.padding-bottom.px]="item?.padding"
                                *ngIf="item?.type == 'LINK'">
                                <a routerLink="{{ item?.content?.link }}">
                                    <button type="button" class="btn btn-primary rounded-pill px-10 font-weight-bold font-size-16"
                                        style="margin-right: 40px;"
                                        [style.background-color]="institution?.bg_color_2"
                                        [style.border-color]="institution?.bg_color_2">
                                        {{ item?.content?.text }}
                                    </button>
                                </a>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
</div>
